define.alias("shared/components/shared/wizards/device-setup/step-two", "media/components/shared/wizards/device-setup/step-two");